import { useEffect, useRef } from 'react';

const featuredProducts = [
  {
    id: 1,
    name: 'Laminam Calacatta Oro',
    category: 'კერამიკული ფილები',
    brand: 'Laminam',
    image: 'https://readdy.ai/api/search-image?query=Calacatta%20Oro%20marble%20look%20large%20format%20ceramic%20tile%20elegant%20white%20with%20gold%20veins%20luxury%20interior%20design%20product%20photography%20warm%20lighting&width=500&height=600&seq=phoenix-feat-1&orientation=portrait',
    tag: 'ბესტსელერი',
  },
  {
    id: 2,
    name: 'Antolini Verde Guatemala',
    category: 'ბუნებრივი ქვა',
    brand: 'Antolini',
    image: 'https://readdy.ai/api/search-image?query=Verde%20Guatemala%20green%20marble%20slab%20luxury%20natural%20stone%20elegant%20veins%20interior%20design%20product%20photography%20warm%20lighting&width=500&height=600&seq=phoenix-feat-2&orientation=portrait',
    tag: 'ახალი',
  },
  {
    id: 3,
    name: 'Hansgrohe Rainfinity',
    category: 'სანტექნიკა',
    brand: 'Hansgrohe',
    image: 'https://readdy.ai/api/search-image?query=Hansgrohe%20Rainfinity%20shower%20system%20chrome%20modern%20bathroom%20luxury%20product%20photography%20warm%20ambient%20lighting%20elegant&width=500&height=600&seq=phoenix-feat-3&orientation=portrait',
    tag: 'პრემიუმ',
  },
  {
    id: 4,
    name: 'Ardex P 51 Primer',
    category: 'საღებავები და შპატლევა',
    brand: 'Ardex',
    image: 'https://readdy.ai/api/search-image?query=Professional%20construction%20primer%20product%20can%20Ardex%20brand%20elegant%20product%20photography%20warm%20lighting%20minimal%20background&width=500&height=600&seq=phoenix-feat-4&orientation=portrait',
    tag: 'პროფესიული',
  },
];

export default function FeaturedProducts() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-up');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const els = sectionRef.current?.querySelectorAll('.reveal');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-[#1A1A1A] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="reveal opacity-0 flex flex-col md:flex-row md:items-end md:justify-between mb-12 md:mb-16">
          <div>
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-[#D4A853] mb-4">
              გამორჩეული
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-3">
              პოპულარული პროდუქტები
            </h2>
            <p className="text-white/50 text-base md:text-lg max-w-xl">
              ჩვენი მომხმარებლების ყველაზე მოთხოვნადი პროდუქტები — პრემიუმ ხარისხი გარანტირებული
            </p>
          </div>
          <a
            href="#categories"
            className="mt-6 md:mt-0 inline-flex items-center gap-2 text-sm font-semibold text-[#D4A853] hover:text-white transition-colors duration-300 whitespace-nowrap"
          >
            ყველა პროდუქტი
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuredProducts.map((product, index) => (
            <div
              key={product.id}
              className="reveal opacity-0 group relative bg-[#252525] rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 hover:bg-[#2D2D2D]"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              {/* Tag */}
              <div className="absolute top-4 left-4 z-10 bg-[#D4A853] text-[#1A1A1A] text-xs font-bold px-3 py-1 rounded-full">
                {product.tag}
              </div>

              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#252525] via-transparent to-transparent opacity-60"></div>
              </div>

              {/* Content */}
              <div className="p-5">
                <p className="text-xs text-[#D4A853] font-medium mb-1">{product.brand}</p>
                <h3 className="font-serif text-lg font-bold text-white mb-1 group-hover:text-[#D4A853] transition-colors duration-300">
                  {product.name}
                </h3>
                <p className="text-sm text-white/40">{product.category}</p>

                <div className="mt-4 flex items-center gap-2 text-sm font-medium text-white/60 group-hover:text-[#D4A853] transition-colors duration-300">
                  <span>მეტის ნახვა</span>
                  <i className="ri-arrow-right-up-line transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}